import { Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import styles from './Headers.module.scss';

interface IComponentHeaderWithEllipsisAndTooltipProps {
    title?: string | React.ReactNode;
    subtitle?: string;
    containerClassName?: string;
    rightSideComponent?: JSX.Element;
    useContainerFontSize?: boolean;
}

const ComponentHeaderWithEllipsisAndTooltip: React.FC<IComponentHeaderWithEllipsisAndTooltipProps> = (props: IComponentHeaderWithEllipsisAndTooltipProps) => {
    const titleReference = useRef<HTMLHeadingElement>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (titleReference.current && typeof props.title === 'string') {
                const isOverflowing = titleReference.current.scrollWidth > titleReference.current.clientWidth;
                setShowTooltip(isOverflowing);
            }
        };

        checkOverflow();
        window.addEventListener('resize', checkOverflow);

        return () => window.removeEventListener('resize', checkOverflow);
    }, [props.title]);

    return (
        <div className={props.containerClassName ?? styles.component_header_container_with_ellipsis}>
            <div className={styles.component_header_flex_with_ellipsis}>
                <div>
                    <Tooltip
                        className={styles.component_header_tooltip}
                        title={showTooltip && typeof props.title === 'string' ? props.title : ''}
                        placement="bottom-start"
                        disableHoverListener={!showTooltip}
                    >
                        <span>
                            <h3
                                ref={titleReference}
                                className={
                                    !props.useContainerFontSize
                                        ? styles.component_header_main_with_ellipsis
                                        : styles.component_header_main_with_ellipsis_container
                                }
                            >
                                {props.title}
                            </h3>
                        </span>
                    </Tooltip>
                </div>
                {props.rightSideComponent && <div className={styles.component_header_rightSide}>{props.rightSideComponent}</div>}
            </div>
            {props.subtitle && <h2 className={styles.component_header_sub}>{props.subtitle}</h2>}
        </div>
    );
};

export default ComponentHeaderWithEllipsisAndTooltip;
